import _ from 'underscore';

import { AlertErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Set } from '~commonInfra/utils/Set';
import { ICheckConnectionResult } from '~src/datasource/dataConnection/serverApi/CheckConnectionRequest';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { Messages } from '../../codegen/Localize';
import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IDataSourceInfo } from '../../datasource/models/IDataSourceInfo';
import { DataSources } from '../../datasource/resources/Datasources';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

function execute(dataSources: Set<IDataSourceInfo>): Promise<IResult>{
  const datasource = dataSources.first();
  const dataSourceIdArray = dataSources.map(ds => ds.id);
  let workbookId = datasource.workbook != null ? datasource.workbook.id : '';
  // Skip the classic embedded-credential pre-check for OAuth connections. OAuth data sources
  // (including workload-identity-federation connections) have no persisted classic embedded
  // credential, so the check would always fail and block the switch to live. This mirrors the
  // OAuth/testing guard from the create-extract path in RunCreateExtractsSaga; the file-based
  // and sqlproxy connection types that path also excludes are already filtered out upstream by
  // openChangeExtractDsToLiveWindow before this action runs.
  const dataSourcesToCheck = dataSources.filter((ds) =>
    ds.dataConnectionsCount === 1 && ds.testingConnectionAllowed && !ds.connectionOAuth);

  const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.changeExtractDsToLive(),
      actionName: Messages.changeExtractDsToLiveConfirm(),
      message: Messages.changeExtractDsToLiveBody(),
      action: async () => {
        if (dataSourcesToCheck.size() > 0) {
          const results: ICheckConnectionResult[] = await DataSources.checkConnections(dataSourcesToCheck);
          if (!_.all(results, result=>result.succeeded)) {
            const failedCheckConection: IResult = {errors:[]};
            let connectionFailureErrorCode = getSessionManagementServiceInstance().isOnlineEnvironment() ?
              AlertErrorCode.AlertConnectionFailureForExtractToLive : AlertErrorCode.AlertConnectionlessFailure;
            dataSourcesToCheck.each(() => {
              failedCheckConection.errors.push({code:connectionFailureErrorCode, message:'connection test failed'});
            });
            if(failedCheckConection && failedCheckConection.errors && failedCheckConection.errors.length)
              {
                  ContentActionNotification.displayToastForGenericError(failedCheckConection.errors[0]);
              }
            return Promise.reject(failedCheckConection);
          }
        }
        const changeToLivePromise = DataSources.changeToLive(dataSourceIdArray, workbookId);
        changeToLivePromise
        .then((result: IResult) => {
          ContentActionNotification.displaySingleToastForResult({
            items: dataSources,
            errors: result.errors,
            successMsg: simpleActionSuccessMsg(Messages.changeExtractDsToLiveSuccess),
            errorMsg: simpleActionErrorMsg(Messages.changeExtractDsToLiveError),
          });
          return result;
      });
      return changeToLivePromise;
      },

      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px

    });

  return dialogConfig.result;
}

export const ChangeExtractDsToLiveAction = {
    execute
};

export type ChangeExtractDsToLiveAction = typeof ChangeExtractDsToLiveAction;
